import React from 'react'
import { connect } from 'react-redux'

import * as Styled from '@chegg-wt/core/components/Folders/shared/ProjectMenu/styled'

import { ProjectTypesListProps } from '@chegg-wt/core/components/Folders/shared/ProjectMenu/types'
import { publicAssetUrl } from '@chegg-wt/core/utils/url'
import { AppState } from '@chegg-wt/core/state'
import { CITATION_LIST_NAME_LOWER_PLURAL } from '@chegg-wt/core/constants/citations'
import { ProjectTypeKeys } from '@chegg-wt/core/constants/projectTypeKey'
import { setFolderId } from '@chegg-wt/core/state/folders/actions'
import { fetchProjects, setProjectFilter } from '@chegg-wt/core/state/projects/actions'
import { projectFilterSelector } from '@chegg-wt/core/state/projects/selectors'

export const ProjectTypesList: React.FunctionComponent<ProjectTypesListProps> = ({
  fetchProjects,
  setProjectFilter,
  setFolderId,
  selectedItem = ProjectTypeKeys.ALL,
}) => {
  return (
    <Styled.ListContainer>
      <Styled.ListItem
        data-selected={selectedItem === ProjectTypeKeys.ALL ? true : undefined}
      >
        <Styled.ItemAction
          type="button"
          onClick={() => {
            setProjectFilter(ProjectTypeKeys.ALL)
            setFolderId(null)
            fetchProjects()
          }}
          aria-pressed={selectedItem === ProjectTypeKeys.ALL}
          data-test="all-projects"
        >
          <Styled.Icon icon={publicAssetUrl('all-projects.svg')} iconSize="20px" />
          <Styled.Label>All {CITATION_LIST_NAME_LOWER_PLURAL}</Styled.Label>
        </Styled.ItemAction>
      </Styled.ListItem>
      <Styled.ListItem
        data-selected={selectedItem === ProjectTypeKeys.STARRED ? true : undefined}
      >
        <Styled.ItemAction
          type="button"
          onClick={() => {
            setProjectFilter(ProjectTypeKeys.STARRED)
            setFolderId(null)
            fetchProjects()
          }}
          aria-pressed={selectedItem === ProjectTypeKeys.STARRED}
          data-test="starred-projects"
        >
          <Styled.Icon
            icon={publicAssetUrl('starred-project-menu.svg')}
            iconSize="20px"
          />
          <Styled.Label>Starred</Styled.Label>
        </Styled.ItemAction>
      </Styled.ListItem>
    </Styled.ListContainer>
  )
}

const mapStateToProps = (state: AppState) => ({
  selectedItem: projectFilterSelector(state),
})

const mapDispatchToProps = {
  setProjectFilter,
  fetchProjects,
  setFolderId,
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectTypesList)
